import { render, staticRenderFns } from "./abtest.vue?vue&type=template&id=56085fa6&"
import script from "./abtest.vue?vue&type=script&lang=js&"
export * from "./abtest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports